import { createContext } from "react";

const initialValue = {
  pou: [],
  user: {
    name: "",
    role: "",
    email: "",
    auth_token: "",
  },
};

export const hospital_Context = createContext(initialValue);

hospital_Context.displayName = "Hospital Context";
